import React, { FC, memo } from 'react';
import { Avatar, ChannelPreviewUIComponentProps } from 'stream-chat-react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { Events } from 'analytics';

interface IProps extends ChannelPreviewUIComponentProps {
  onToggleDrawer: () => void;
}

const useStyles = makeStyles(theme => ({
  item: {
    padding: theme.spacing(2),
    cursor: 'pointer',
    border: `1px solid transparent`,
    borderBottomColor: theme.palette.grey[300],
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  itemActive: {
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.grey[300],
    boxShadow: `0px -1px 0px ${theme.palette.common.white}`,
    borderRadius: 4,
  },
  breakWord: {
    maxWidth: (theme.custom.bodyMaxWidth / 12) * 2,
    ...theme.mixins.breakWord,
  },
  latestMessage: {
    fontSize: theme.typography.pxToRem(11),
  },
}));

const ChannelPreview: FC<IProps> = props => {
  const {
    active,
    displayImage,
    displayTitle,
    latestMessage,
    unread,
    setActiveChannel,
    channel,
    onToggleDrawer,
  } = props;
  const classes = useStyles();

  const lastMessageVariant = !!unread ? 'body2' : 'body1';
  const itemClasses = classNames(classes.item, {
    [classes.itemActive]: active,
  });

  function handleChangeChannel() {
    analytics.track(Events.ClickMenuDiscussion);
    setActiveChannel(channel);
    onToggleDrawer();
  }

  return (
    <div className={itemClasses} onClick={handleChangeChannel}>
      <Grid container spacing={1}>
        <Grid item>
          <Avatar shape="rounded" image={displayImage} />
        </Grid>
        <Grid item xs>
          <Typography className={classes.breakWord} variant="body2">
            {displayTitle}
          </Typography>
          <Typography
            className={classNames(classes.breakWord, classes.latestMessage)}
            variant={lastMessageVariant}>
            {latestMessage}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(ChannelPreview);
